import { Text } from '@react-pdf/renderer';
import type { TextProps } from '@react-pdf/renderer';
import type React from 'react';

type TypographyProps = {
  children: React.ReactNode;
  style?: TextProps['style'];
};

export const Typography = ({
  children,
  style,
}: TypographyProps): React.ReactNode => {
  return <Text style={style}>{children}</Text>;
};
